// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__2QY3W","row":"Option_row__Gv6-f"};